
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[vendor]/cart",
      function () {
        return require("private-next-pages/[vendor]/cart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[vendor]/cart"])
      });
    }
  